module.exports = "<button class=\"par-btn\" [type]=\"buttonType\" [disabled]=\"disabled\" (click)=\"buttonClick()\" [ngClass]=\"buttonDesign\">{{buttonText}}</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/par-library/form-components/par-button/par-button.component.html
// module id = ./src/app/par-library/form-components/par-button/par-button.component.html
// module chunks = main